module.exports = __webpack_public_path__ + "static/media/pacing-large@3x.88e3bf84.png";